import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {HttpClientModule} from '@angular/common/http';
import { HomeComponent } from './home/home.component';
import { LiveComponent } from './live/live.component';
import { AlbumComponent } from './album/album.component';
import {IvyGalleryModule} from 'angular-gallery';
import { MediaComponent } from './media/media.component';
import { FooterComponent } from './footer/footer.component';
import { SpecialComponent } from './special/special.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { SpotifyComponent } from './spotify/spotify.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LiveComponent,
    AlbumComponent,
    MediaComponent,
    FooterComponent,
    SpecialComponent,
    ImpressumComponent,
    SpotifyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatChipsModule,
    MatIconModule,
    HttpClientModule,
    IvyGalleryModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
